import { render } from "./AdicionarPlanoProfissional.vue?vue&type=template&id=e0a8c5be&scoped=true"
import script from "./AdicionarPlanoProfissional.vue?vue&type=script&lang=js"
export * from "./AdicionarPlanoProfissional.vue?vue&type=script&lang=js"

import "./AdicionarPlanoProfissional.vue?vue&type=style&index=0&id=e0a8c5be&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a8c5be"]])

export default __exports__